const baseGroupMapping = {
  mentality: "mentality_milieusFilter",
  fintality: "fintality_milieusFilter",
  burgerschapsstijlen: "burgerschapsstijlen_milieusFilter",
  shopperMentality: "shopperMentality_milieusFilter",
  vitality: "vitality_milieusFilter",
  zorgMentality: "zorgMentality_milieusFilter",
  VijfTintenGroener: "vijfTintenGroener_milieusFilter",
  vrijetijdsprofielen: "vrijetijdsprofielen_milieusFilter",
  demografie: "socioDemographicsFilter",
  archetypen: "archetypesFilter",
  lifestyle: "lifestyleFilter",
  onderstromen: "onderstromenFilter",
  waardekaarten: "valuesCardsFilter",
  merken: "brandsFilter",
  duurzaamheid: "sustainabilityFilter",
  politiek: "politicsFilter",
  media: "mediaFilter",
  overtuigingsstrategieën: "persuasionTacticsFilter",
};

const referenceGroupMapping = {
  mentality: "mentality_milieusReference",
  fintality: "fintality_milieusReference",
  burgerschapsstijlen: "burgerschapsstijlen_milieusReference",
  shoppermentality: "shoppermentality_milieusReference",
  vitality: "vitality_milieusReference",
  zorgmentality: "zorgmentality_milieusReference",
  vijftintengroener: "vijftintengroener_milieusReference",
  vrijetijdsprofielen: "vrijetijdsprofielen_milieusReference",
  demografie: "socioDemographicsReference",
  archetypen: "archetypesReference",
  lifestyle: "lifestyleReference",
  onderstromen: "onderstromenReference",
  waardekaarten: "valuesCardsReference",
  merken: "brandsReference",
  duurzaamheid: "sustainabilityReference",
  politiek: "politicsReference",
  media: "mediaReference",
  overtuigingsstrategieën: "persuasionTacticsReference",
};

export function mappingFunction(baseGroup, referenceGroup) {
  const params = {};
  // Create basegroup params.
  Object.keys(baseGroup).forEach((filterName) => {
    const paramsKey = baseGroupMapping[filterName];
    let paramsValues = [];
    baseGroup[filterName].forEach((item) => {
      paramsValues.push(item.value);
    });
    params[paramsKey] = paramsValues;
  });
  // Create referencegroup params
  Object.keys(referenceGroup).forEach((filterName) => {
    const paramsKey = referenceGroupMapping[filterName];
    let paramsValues = [];
    referenceGroup[filterName].forEach((item) => {
      paramsValues.push(item.value);
    });
    params[paramsKey] = paramsValues;
  });
  return params;
}
